// These colors are copied from `ui/_colors.scss`
export function getBackgroundColor(color: string) {
    switch (color) {
        case 'pink':
            return '#ffe4e6'; // colors.$red-100
        case 'yellow':
            return '#fdedd3'; // colors.$yellow-100
        case 'purple':
            return '#e0e7ff'; // colors.$indigo-100
        case 'green':
            return '#cceede'; // colors.$green-100
        case 'grey':
        default: {
            return '#e5e7eb'; // colors.$grey-200
        }
    }
}

export function getTextColor(color: string) {
    switch (color) {
        case 'pink':
            return '#3a0818'; // colors.$red-900
        case 'yellow':
            return '#312107'; // colors.$yellow-900
        case 'purple':
            return '#1b1b38'; // colors.$indigo-900
        case 'green':
            return '#002212'; // colors.$green-900
        case 'grey':
        default: {
            return '#111827'; // colors.$grey-900
        }
    }
}
